module.exports = __webpack_public_path__ + "static/media/token.ce5cf2f8.png";